














































import Dialog from "@/mixins/Dialog";
import {Component, Mixins,} from "vue-property-decorator";
import SendVerifyCode from './SendVerifyCode.vue';
import {system_info} from "@/core/utils";
@Component({
  components: {
    SendVerifyCode
  }
})
export default class ApplyTrialAccountDialog extends Mixins(Dialog){
  //参数
  private params:any={
    lawfirm_name:'',
    name:'',
    mobile:'',
    plat_id:'',
    sms_code:''
  }
  // private params:any={
  //   lawfirm_name:'测试机构003',
  //   name:'测试人员003',
  //   mobile:15558677773,
  //   plat_id:74,
  //   sms_code:'000000'
  // }
  //校验规则
  private rules:any={
    lawfirm_name: [
      { required: true, message: '请输入机构名称', trigger: 'blur' },
    ],
    name: [
      { required: true, message: '请输入姓名', trigger: 'blur' },
    ],
    mobile: [
      { required: true, message: '请输入手机号', trigger: 'blur' },
      { pattern: /^\d{11}$/, message: '请输入正确的手机号', trigger: 'blur' },
    ],
    sms_code: [
      { required: true, message: '请输入验证码', trigger: 'blur' },
    ],
  }
  // 19924252557
  //打开弹窗
  public open() {
    this.dialog_visible = true;
  }

  //发送申请
  private submit(){
    (this.$refs as any).dialog_form.validate((valid:any) => {
      if (valid) {
        this.loading = true
        console.log(this.params, '申请试用')
        this.params.plat_id = system_info.get('id');
        this.$noSign.post(this.$URL.APPLY_ACCOUNT,this.params).then((res:any)=>{
          this.loading = false;
          console.log(res , '申请试用')
          if( res.code == 1){
            this.$message({
              type:'success',
              message: res.msg,
              duration:5000,
            });
            this.params={
              lawfirm_name:'',
              name:'',
              mobile:null,
              plat_id:'',
              sms_code:null
            }
            this.dialog_visible = false;
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            });
          }
        })
      }
    })
  }

  //发送验证码失败
  private onSendVerifyCodeFail(message: string) {
    // this.$message.errors.mobile = message;
    console.log('失败',message)
    this.$message.error(message)
  }

  //关闭弹窗
  public handleClose(){
    this.params={
      lawfirm_name:'',
      name:'',
      mobile:'',
      plat_id:'',
      sms_code:null
    }
    this.dialog_visible = false;
  }
}
